import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useBrandConfiguration } from '@search/core/brands/context';
import { useSerpTranslation } from '@search/core/hooks/useI18n';
import { useSearchTitle } from '@search/core/hooks/useSearchTitle';
import isNumber from 'lodash/isNumber';
import { useAppContext } from '../../contexts/AppContext';
export const SearchTitleVariantATestId = 'serp-title-variant-a-testid';
export const SearchTitleVariantBTestId = 'serp-title-variant-b-testid';
const VariantA = () => {
    const [searchModel, pageData, searchIndex, hubContent, totalCount, appName] = useAppContext((store) => [
        store.searchModel,
        store.pageData,
        store.searchIndex,
        store.hubContent,
        store.totalCount,
        store.appConfig.appName,
    ]);
    const { t } = useSerpTranslation();
    let title = searchModel && useSearchTitle({ searchModel, pageData, updateTrigger: searchIndex, hubContent, appName });
    if (isNumber(totalCount)) {
        const resultLabel = totalCount === 1
            ? t('header.results.label_one', { count: totalCount })
            : t('header.results.label_other', { count: totalCount });
        title = `${title} - ${resultLabel}`;
    }
    return (_jsx(Box, { as: "h1", marginBottom: {
            'breakpoint.base': 'spacing.16',
            'breakpoint.sm': 'spacing.24',
        }, marginTop: "spacing.none", textAlign: "left", typography: "typography.headline.24.bold", testId: SearchTitleVariantATestId, children: title || '' }));
};
const VariantB = () => {
    const [searchModel, pageData, searchIndex, hubContent, appName] = useAppContext((store) => [
        store.searchModel,
        store.pageData,
        store.searchIndex,
        store.hubContent,
        store.appConfig.appName,
    ]);
    const title = searchModel && useSearchTitle({ searchModel, pageData, updateTrigger: searchIndex, hubContent, appName });
    return (_jsx(Box, { as: "h1", marginTop: "spacing.none", marginBottom: {
            'breakpoint.base': 'spacing.16',
            'breakpoint.sm': 'spacing.24',
        }, textAlign: "left", typography: "typography.headline.24.bold", testId: SearchTitleVariantBTestId, children: title || '' }));
};
export const SearchTitle = () => {
    const { variant } = useBrandConfiguration();
    if (variant === 'flagship') {
        return _jsx(VariantA, {});
    }
    return _jsx(VariantB, {});
};
